/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum EmailSort {
  'to_email,asc' = 'to_email,asc',
  'to_email,desc' = 'to_email,desc',
  'sent_at,asc' = 'sent_at,asc',
  'sent_at,desc' = 'sent_at,desc'
}
